import { connect } from 'react-redux'
import { map } from 'lodash'
import { toggleShowClosedTabs, clearSearch, setShowOnlyActiveAttendantOrders } from '../../actions/search'
import { withRouter } from 'react-router-dom'

import { getIsSuitesMode } from '../../selectors/config'
import { getShowClosedTabs, getShowOnlyActiveAttendantOrders } from '../../selectors/search'
import { makeGetDisplaySuites } from '../../selectors/suites'

import OrderListControlBar from '../../components/tabs/OrderListControlBar'
import { makeGetTabOrders } from '../../selectors/order'
import { getRowPayment } from '../../viewmodels/TabOrderViewModel'

const mapStateToProps = (state) => {
  const isSuites = getIsSuitesMode(state)
  const showClosedTabs = getShowClosedTabs(state)

  const getDisplaySuites = makeGetDisplaySuites()
  const displaySuites = getDisplaySuites(state)
  const getTabOrders = makeGetTabOrders(state)
  const orders = getTabOrders(state)
  const showOnlyActiveAttendantOrders = getShowOnlyActiveAttendantOrders(state)

  let searchData
  if (isSuites) {
    searchData = map(displaySuites, (suite) => ({ name: suite.displayName, id: `${suite.revenueCenterId}${suite.customerId}` }))
  } else {
    searchData = map(orders, (order) => ({ name: `${getRowPayment(order)} ${order.userNotes} ${order.orderNumber}`, id: order.uuid }))
  }
  return { searchData, isSuites, showClosedTabs, showOnlyActiveAttendantOrders }
}

const mapDispatchToProps = (dispatch, props) => {
  const replace = props?.history?.replace ?? (() => {})

  return {
    toggleShowClosedTabs: () => dispatch(toggleShowClosedTabs()),
    clearSearch: () => dispatch(clearSearch()),
    setShowOnlyActiveAttendantOrders: (newStatus) => dispatch(setShowOnlyActiveAttendantOrders(newStatus)),
    showAttendantSummary: () => replace('tabs/attendant/summary-report'),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrderListControlBar))
